'use client';

import { useProduct } from '@/components/product/product-context';
import offsetBlockClass from '@/utils/offsetBlockClass';
import TrueMedWidget from '@/utils/truemed';

// Widget Registry
const WIDGET_COMPONENTS = {
  TrueMed: {
    component: TrueMedWidget,
    getProps: ({ shopifyProduct }) => ({
      checkout: false,
      productId: shopifyProduct.id,
      eligible: shopifyProduct?.truemedEligible ?? false,
      className: '!mt-0 !p-0' // override default style from truemed.js
    })
  }
};

export default function PpdWidget({ block, position }) {
  const { productData } = useProduct();
  const shopifyProduct = productData?.shopifyProduct;
  const { type, spacing, show_offset_block_selector, uid } =
    block?.pdp_widget?.reference[0];

  const spacing_class =
    spacing === 'Append above' && show_offset_block_selector === 'multi-block'
      ? 'not-last:-mb-4!'
      : spacing === 'Append above'
        ? 'not-last:mb-4!'
        : spacing === 'Append below'
          ? '-mt-4!'
          : '';
  const widgetConfig = WIDGET_COMPONENTS[type];

  if (!widgetConfig) {
    console.error(
      `Widget type "${type}" not found in registry. Available types: ${Object.keys(WIDGET_COMPONENTS).join(', ')}`
    );
    return null;
  }

  const WidgetComponent = widgetConfig.component;
  const widgetProps = widgetConfig.getProps({ shopifyProduct });

  return (
    <section
      id={`${uid}_${position}`}
      className={`flex flex-col items-center justify-center text-center ${spacing_class} ${offsetBlockClass(show_offset_block_selector, 'not-last:mb-8')}`}
    >
      <WidgetComponent {...widgetProps} />
    </section>
  );
}
